export default __webpack_public_path__ + "static/related-people-and-groups-light-mode-a1fc9298ee3e4b823321a0a46227ddfc.png";